module.exports = __webpack_public_path__ + "static/media/pay-online-restaurant.016ae34e.svg";